import { type Application } from '@/portal-api.definition';
import { SkeletonLight } from '../skeleton/skeleton.light';
import { AppCardLight } from '../apps-card/apps-card.light';

export function AppListLight({
  apps,
  isLoading,
}: Readonly<{ apps: Application[]; isLoading: boolean }>) {
  return (
    <div className="grid gap-2 overflow-y-auto">
      <SkeletonLight loading={isLoading} className="h-20 rounded" count={10}>
        <div className="grid gap-2">
          {apps.map((app) => (
            <AppCardLight key={app.Id} app={app} />
          ))}
        </div>
      </SkeletonLight>
    </div>
  );
}
